import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { ApplicationForm } from './pages/ApplicationForm';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsOfService } from './pages/TermsOfService';
export function AppRouter() {
  return <BrowserRouter data-id="element-15">
      <Routes data-id="element-16">
        <Route path="/" element={<App data-id="element-18" />} data-id="element-17" />
        <Route path="/application" element={<ApplicationForm data-id="element-20" />} data-id="element-19" />
        <Route path="/privacy" element={<PrivacyPolicy data-id="element-22" />} data-id="element-21" />
        <Route path="/terms" element={<TermsOfService data-id="element-24" />} data-id="element-23" />
      </Routes>
    </BrowserRouter>;
}